<template>
    <div class="public_container">
        <Head></Head>
        <div class="mobile_container">
            待办
        </div>
        <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
    </div>
</template>
<script>
import Head from '@/components/mComponents/Head.vue'
import FooterTabbar from '@/components/mComponents/FooterTabbar.vue'
export default {
    name: 'mobileTodo',
    data () {
        return {
            tabBarList:[
                {
                    icon:'icon-gongzuotai_weixuanzhong1',
                    activeIcon:'icon-gongzuotai_xuanzhong',
                    routerName:'mobileWorkBench',
                    title:'工作台'
                },
                {
                    icon:'icon-renwu_weixuanzhong',
                    activeIcon:'icon-renwu_xuanzhong',
                    routerName:'mobileTodo',
                    title:'待办'
                },
                {
                    icon:'icon-xiaoxi',
                    activeIcon:'icon-xiaoxi1',
                    routerName:'Message',
                    title:'消息'
                },
                {
                    icon:'icon-gengduogongneng_weixuanzhong',
                    activeIcon:'icon-gengduogongneng_xuanzhong',
                    routerName:'mobileAllFunctions',
                    title:'全部'
                },
            ],
            tabBarActive:1
        }
    },
    mounted () {

    },
    methods: {},
    components: {
        Head,
        FooterTabbar
    }
}
</script>

<style lang="scss" scoped>

</style>
